import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteEmailPromoModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteEmailPromoModalContainer" */
      './DeleteEmailPromoModalContainer'
    ),
  loading: LoadingModal,
});
